import {
  ActivityIndicator,
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import {
  FIREBASE_EVENT_NAMES,
  FIREBASE_EVENT_PARAMS,
  PAGES_ROUTES,
  PAGES_TITLE,
} from "utils/Constants";
import React, { useCallback, useEffect, useState } from "react";
import Svg, { Path } from "react-native-svg";
import { fp, hp, normalize, spH, spV, wp } from "utils/normalizeV2";
import {
  getUserAddressList,
  setBillingAddress,
  setDeliveryAddress,
} from "appRedux/reducers/orderSlice";
import { router, useLocalSearchParams } from "expo-router";
import { useDispatch, useSelector } from "react-redux";

import Accordion from "components/Accordion";
import AddressCard from "components/checkout/AddressCard";
import Buttons from "components/Buttons";
import { Colors } from "colors";
import { Images } from "assets";
import { Svg as svgs } from "assets/svg";
import ListView from "components/ListView";
import ParentScrollView from "components/ParentScrollView";
import SideProfileComp from "components/profile/SideProfileComp";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { logEvent } from "firebase/analytics";
import { useRef } from "react";
import { trackV2 } from "utils/Segment";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import EmptyScreen from "components/emptyScreen";

const AddressList = (props) => {
  const local = useLocalSearchParams();
  const pageType = local?.type;
  const [isBillingAddressSame, setIsBillingAddressSame] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const userId = useSelector((state) => state.AuthReducer.userId);
  const deliveryAddress = useSelector(
    (state) => state.OrderReducer.deliveryAddress
  );
  const billingAddress = useSelector(
    (state) => state.OrderReducer.billingAddress
  );
  const userAddressListLoading = useSelector(
    (state) => state.OrderReducer.userAddressListLoading
  );
  const userAddressList = useSelector(
    (state) => state.OrderReducer.userAddressList
  );
  const country = useSelector((state) => state.StoredutilsSlice.country);

  const _changeAddRef = useRef();
  const dispatch = useDispatch();
  const rotate = useSharedValue(0);
  const localGender = local?.gender || "female";

  const animatedStyles = useAnimatedStyle(() => ({
    transform: [{ rotateZ: `${rotate.value}deg` }],
  }));

  useEffect(() => {
    const eventData = {
      saved_addresses_count: userAddressList?.length,
    };
    trackV2(ANALYTICS_EVENT_NAMES.SAVED_ADDRESSES_PAGE_VIEWED, eventData);
  }, [userAddressList?.length]);

  useEffect(() => {
    dispatch(setBillingAddress());
  }, []);

  useEffect(() => {
    dispatch(getUserAddressList())
      .then((res) => {
        if (
          [200].includes(res.payload?.status) &&
          Array.isArray(res?.payload?.data) &&
          res?.payload?.data?.length == 0 &&
          pageType != "profile"
        ) {
          router.push(`${localGender == "men" ? "/men" : ""}/add-address`);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, [pageType, localGender]);

  useEffect(() => {
    if (deliveryAddress && isBillingAddressSame) {
      dispatch(setBillingAddress(deliveryAddress));
    }
  }, [deliveryAddress, isBillingAddressSame]);

  useEffect(() => {
    if (
      userAddressList &&
      Array.isArray(userAddressList) &&
      userAddressList?.[0]
    ) {
      dispatch(setDeliveryAddress(userAddressList?.[0]));
    }
  }, [userAddressList]);

  const onPressProceed = () => {
    router.push(`${localGender == "men" ? "/men" : ""}/order-summary`);
  };

  const onPressChangeBtn = useCallback(() => {
    setIsOpen((prev) => {
      if (prev == true) {
        rotate.value = withTiming(0);
        return false;
      } else {
        rotate.value = withTiming(180);
        return true;
      }
    });
  }, []);

  const renderDeliveryItem = useCallback(
    (data) => {
      const { item } = data;
      const add = `${item.addressLine1} ${item.addressLine2}, ${item.city} ${item.state}, Pin: ${item.pincode}, ${item.country}`;

      return (
        <AddressCard
          onPressEditBtn={() => {
            if (pageType == "profile") {
              router.push(
                `${localGender == "men" ? "/men" : ""}/add-address?id=${
                  item?.id
                }&isProfile=true`
              );
            } else {
              router.push(
                `${localGender == "men" ? "/men" : ""}/add-address?id=${
                  item?.id
                }`
              );
            }
          }}
          name={item?.type ? item?.type : item?.name}
          address={add}
          item={item}
          onPressSelectBtn={() => {
            const eventData = {
              address_type: "shipping",
              action_type: "select_existing",
              address_count: userAddressList?.length,
            };
            trackV2(ANALYTICS_EVENT_NAMES.ADDRESS_SELECTED, eventData);
            dispatch(setDeliveryAddress(item));
          }}
          selectedAddress={deliveryAddress}
        />
      );
    },
    [deliveryAddress]
  );

  const renderBillingItem = useCallback(
    (data) => {
      const { item } = data;
      const add = `${item.addressLine1} ${item.addressLine2}, ${item.city} ${item.state} ${item.pincode}`;

      return (
        <AddressCard
          onPressEditBtn={() => {
            router.push(
              `${localGender == "men" ? "/men" : ""}/add-address?id=${
                item?.id
              }&isBilling=true`
            );
          }}
          name={item?.type ? item?.type : item?.name}
          address={add}
          item={item}
          onPressSelectBtn={() => {
            const eventData = {
              address_type: "billing",
              action_type: "select_existing",
              address_count: userAddressList?.length,
            };
            trackV2(ANALYTICS_EVENT_NAMES.ADDRESS_SELECTED, eventData);
            dispatch(setBillingAddress(item));
          }}
          selectedAddress={billingAddress}
        />
      );
    },
    [billingAddress]
  );

  const returnAddressViews = () => {
    return (
      <>
        <View style={styles.addressViewContainer}>
          <ListView
            extraData={[userAddressList]}
            showsVerticalScrollIndicator={false}
            data={userAddressList}
            renderItem={renderDeliveryItem}
            keyExtractor={(item) => item?.id.toString()}
            ListEmptyComponent={() => (
              <View style={styles.parentContainer}>
                <VText>No Addresses</VText>
              </View>
            )}
          />
          <View style={styles.bottomView}>
            {billingAddress && (
              <Buttons
                text={"Add New Address"}
                isInverse
                noBorder={false}
                containerStyle={[styles.addNewAddressButton, { marginTop: 16 }]}
                onPress={() => {
                  router.push(
                    `${localGender == "men" ? "/men" : ""}/add-address`
                  );
                }}
              />
            )}
            <View
              style={{
                flex: 1,
              }}
            >
              {billingAddress && (
                <View style={styles.billingView}>
                  <View>
                    <VText
                      style={styles.billingTitle}
                    >{`${"Billing address"} : ${
                      billingAddress?.type || billingAddress?.name
                    }`}</VText>
                    <VText style={styles.addressText}>
                      {`${billingAddress?.addressLine1} ${billingAddress?.addressLine2} ${billingAddress?.city}, ${billingAddress?.state} ${billingAddress?.pincode}`}
                    </VText>
                  </View>
                  <TouchableOpacity
                    onPress={onPressChangeBtn}
                    style={styles.selectBtn}
                    activeOpacity={0.8}
                  >
                    <VText style={styles.changeText}>Change</VText>
                    <Animated.View style={animatedStyles}>
                      <Svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <Path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4 8.29936L5.29936 7L12 13.7006L18.7006 7L20 8.29936L12 16.2994L4 8.29936Z"
                          fill="#212427"
                        />
                      </Svg>
                    </Animated.View>
                  </TouchableOpacity>
                </View>
              )}

              {userAddressList?.length > 0 && !billingAddress && (
                <View style={styles.billingView}>
                  <TouchableOpacity
                    style={styles.checkboxContainer}
                    activeOpacity={0.8}
                    onPress={() => {
                      setIsBillingAddressSame(true);
                    }}
                  ></TouchableOpacity>
                  <VText style={styles.billingText}>
                    Billing Address same as Shipping Address
                  </VText>
                  <TouchableOpacity
                    onPress={onPressChangeBtn}
                    style={styles.selectBtn}
                    activeOpacity={0.8}
                  >
                    <VText style={styles.selectOtherText}>Select other</VText>
                    <Animated.View style={animatedStyles}>
                      <Svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <Path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4 8.29936L5.29936 7L12 13.7006L18.7006 7L20 8.29936L12 16.2994L4 8.29936Z"
                          fill="#212427"
                        />
                      </Svg>
                    </Animated.View>
                  </TouchableOpacity>
                </View>
              )}
            </View>
            <Accordion viewKey="qwerty" isExpanded={isOpen}>
              <View style={styles.accordionContent}>
                <ListView
                  extraData={[userAddressList]}
                  showsVerticalScrollIndicator={false}
                  data={userAddressList}
                  renderItem={renderBillingItem}
                  keyExtractor={(item) => item?.id.toString()}
                  ListEmptyComponent={() => (
                    <View style={styles.parentContainer}>
                      <VText>No Addresses</VText>
                    </View>
                  )}
                />
              </View>
            </Accordion>
            {billingAddress && (
              <View style={[styles.buttonContainer, { padding: 0 }]}>
                {isOpen && (
                  <Buttons
                    text={"Add New Address"}
                    isInverse
                    noBorder={false}
                    containerStyle={styles.addNewAddressButton}
                    onPress={() => {
                      router.push(
                        `${
                          localGender == "men" ? "/men" : ""
                        }/add-address?isBilling=true`
                      );
                    }}
                  />
                )}

                <Buttons
                  text={"Review Order"}
                  containerStyle={[
                    styles.reviewOrderButton,
                    {
                      opacity: !(
                        billingAddress &&
                        deliveryAddress &&
                        deliveryAddress?.country == country?.name
                      )
                        ? 0.6
                        : 1,
                    },
                  ]}
                  disabled={
                    !(
                      billingAddress &&
                      deliveryAddress &&
                      deliveryAddress?.country == country?.name
                    )
                  }
                  onPress={onPressProceed}
                />
              </View>
            )}
            {!billingAddress && (
              <View style={styles.buttonContainer}>
                <Buttons
                  text={"Add New Address"}
                  isInverse
                  noBorder={false}
                  containerStyle={styles.addNewAddressButton}
                  onPress={() => {
                    router.push(
                      `${localGender == "men" ? "/men" : ""}/add-address`
                    );
                  }}
                />

                <Buttons
                  text={"Review Order"}
                  containerStyle={[
                    styles.reviewOrderButton,
                    {
                      opacity: !(billingAddress && deliveryAddress) ? 0.6 : 1,
                    },
                  ]}
                  disabled={!(billingAddress && deliveryAddress)}
                  onPress={onPressProceed}
                />
              </View>
            )}
          </View>
        </View>
      </>
    );
  };

  const renderProfileAddressContent = () => {
    if (userAddressList.length === 0) {
      return (
        <EmptyScreen
          icon={svgs.savedAddress}
          title={"No addresses saved"}
          description={"Please add a new address to save for future use."}
          buttonText={"Add New Address"}
          onPress={() =>
            router.push(
              `${localGender == "men" ? "/men" : ""}/add-address?isProfile=true`
            )
          }
        />
      );
    }
    return (
      <>
        <ListView
          extraData={[userAddressList]}
          showsVerticalScrollIndicator={false}
          data={userAddressList}
          renderItem={renderDeliveryItem}
          keyExtractor={(item) => item?.id.toString()}
          ListEmptyComponent={() => (
            <View style={styles.parentContainer}>
              <VText>No Addresses</VText>
            </View>
          )}
        />
        <Buttons
          text={"Add New Address"}
          isInverse
          noBorder={false}
          containerStyle={[styles.addNewAddressButton, { marginTop: spV(20) }]}
          onPress={() => {
            if (pageType == "profile") {
              router.push(
                `${
                  localGender == "men" ? "/men" : ""
                }/add-address?isProfile=true`
              );
            } else {
              router.push(`${localGender == "men" ? "/men" : ""}/add-address`);
            }
          }}
        />
      </>
    );
  };

  const renderDiffCountryNote = () => {
    return (
      <View style={styles.differentNoteContainer}>
        <VText style={styles.differentNoteText}>
          Currently selected address is out of your country zone. Please change
          your address for shipping.
        </VText>
      </View>
    );
  };

  if (pageType == "profile") {
    return (
      <ParentScrollView>
        <View style={styles.profileAddressContainer}>
          {/* { (deliveryAddress?.country != country.name) && renderDiffCountryNote() } */}
          <VText style={styles.header}>Saved Addresses</VText>
          <View style={styles.content}>
            <SideProfileComp gender={localGender} selected="Saved Addresses" />
            <View style={styles.orderHistorySection}>
              {renderProfileAddressContent()}
            </View>
          </View>
        </View>
      </ParentScrollView>
    );
  }

  return (
    <ParentScrollView>
      <View style={styles.container}>
        {deliveryAddress?.country != country.name && renderDiffCountryNote()}
        <View style={styles.headerContainer}>
          <VText style={styles.headerText}>Add/Select Address</VText>
        </View>

        {!userAddressListLoading && <>{returnAddressViews()}</>}
        {userAddressListLoading && (
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="large" color={Colors.black} />
          </View>
        )}
      </View>
    </ParentScrollView>
  );
};

export default React.memo(AddressList);

const styles = StyleSheet.create({
  profileAddressContainer: {
    backgroundColor: Colors.white,
    paddingTop: spV(32),
  },
  header: {
    textAlign: "center",
    fontSize: fp(28),
    fontFamily: "LibreBodoni",
    fontWeight: "350",
    marginBottom: spV(28),
  },
  content: {
    flex: 1,
    flexDirection: "row",
  },
  menuSection: {
    marginLeft: spH(70),
    width: "20%",
    paddingRight: spH(20),
    borderRightWidth: 1,
    borderRightColor: "#eee",
  },
  orderHistorySection: {
    width: wp(652),
    marginHorizontal: spH(80),
  },
  menuItem: {
    flexDirection: "row",
    alignItems: "center",
    height: spV(65),
    paddingRight: spH(16),
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
  },
  menuItemText: {
    fontSize: 16,
    marginLeft: 15,
    flex: 1,
  },
  chevron: {
    width: spH(15),
    height: spH(15),
    marginLeft: "auto",
  },
  menuItemIcon: {
    width: spH(21),
    height: spH(21),
  },
  container: {
    backgroundColor: "#fff",
    paddingTop: spV(32),
    paddingLeft: spH(200),
    width: wp(500),
  },
  parentContainer: {
    alignItems: "center",
  },
  bottomView: {
    paddingBottom: spV(32),
  },
  billingView: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    minHeight: spV(50),
    paddingVertical: spV(16),
    justifyContent: "space-between",
    width: wp(500),
  },
  billingText: {
    flex: 1,
    fontWeight: "350",
    fontSize: fp(15),
    lineHeight: fp(20),
    color: "rgba(33, 36, 39, 0.6)",
    marginLeft: spH(16),
  },
  selectBtn: {
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderRadius: 3,
    borderColor: Colors.black60,
    flexDirection: "row",
    paddingVertical: spV(8),
    paddingHorizontal: spH(16),
    alignSelf: "flex-end",
  },
  changeBtn: {
    width: wp(65),
    alignItems: "center",
    justifyContent: "center",
    height: hp(25),
    borderWidth: 1,
    borderRadius: 3,
    borderColor: Colors.black60,
  },
  addressText: {
    width: "85%",
    fontWeight: "350",
    fontSize: fp(16),
    color: "rgba(33, 36, 39, 0.6)",
    lineHeight: fp(20),
  },
  billingTitle: {
    fontWeight: "350",
    fontSize: fp(16),
    color: "rgba(33, 36, 39, 0.6)",
    lineHeight: fp(20),
  },
  addressViewContainer: {
    flex: 1,
    width: wp(500),
  },
  addNewAddressButton: {
    width: wp(230),
  },
  checkboxContainer: {
    height: hp(16),
    width: wp(16),
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.16)",
  },
  selectOtherText: {
    fontSize: fp(16),
    lineHeight: fp(16),
    color: "rgba(51, 51, 51, 1)",
  },
  accordionContent: {
    backgroundColor: "rgba(247, 247, 247, 1)",
    paddingHorizontal: spH(28),
    marginVertical: spV(10),
  },
  reviewOrderButton: {
    marginLeft: 4,
    opacity: 1,
    width: "50%",
  },
  buttonContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: spH(16),
    paddingTop: spV(16),
  },
  headerContainer: {
    paddingBottom: hp(16),
    borderBottomWidth: 1,
    borderColor: "rgba(33, 36, 39, 0.3)",
    width: wp(500),
  },
  headerText: {
    fontSize: fp(20),
    color: "rgba(33, 36, 39, 1)",
    fontFamily: "LibreBodoni",
  },
  loadingContainer: {
    paddingVertical: spV(16),
  },
  changeText: {
    fontSize: fp(16),
    lineHeight: fp(16),
    color: "rgba(51, 51, 51, 1)",
  },
  emptyContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  emptyImage: {
    width: 60,
    height: 60,
  },
  emptyButton: {
    width: wp(230),
    marginTop: spV(15),
  },
  emptyText: {
    fontFamily: "JosefinSans",
    fontSize: 20,
    lineHeight: 24,
    fontWeight: "550",
    textAlign: "center",
    marginTop: spV(15),
  },
  emptySubText: {
    fontFamily: "JosefinSans",
    fontSize: 16,
    lineHeight: 22,
    fontWeight: "350",
    textAlign: "center",
    marginTop: spV(5),
  },
  differentNoteContainer: {
    paddingHorizontal: spH(20),
    paddingVertical: spV(10),
    backgroundColor: "#E5E5E5",
    width: wp(500),
    marginBottom: spV(30),
  },
  differentNoteText: {
    fontSize: fp(15),
    paddingRight: spH(10),
    fontWeight: "350",
    color: "#333333",
    // lineHeight: fp(22)
  },
});
